import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, Instagram } from "lucide-react";
import Logo from "./Logo";
import { CONTACTS } from "../lib/whatsapp";

export const Footer = () => {
  return (
    <footer className="bg-[#0F0F10] text-white" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 py-16 md:py-20 grid md:grid-cols-4 gap-12">
        <div className="md:col-span-1">
          <Logo variant="light" />
          <p className="mt-6 text-sm text-white/70 leading-relaxed">
            Outsourcing de impressão, automação e fabricação de etiquetas sob demanda.
            Parceiro estratégico para empresas que querem evoluir.
          </p>
          <a
            href="https://instagram.com/avantech.inf"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 mt-6 text-sm text-white/70 hover:text-[#E84E34] transition-colors"
            data-testid="footer-instagram"
          >
            <Instagram size={18} /> @avantech.inf
          </a>
        </div>

        <div>
          <h4 className="font-display text-xs font-bold uppercase tracking-[0.2em] text-[#E84E34]">Navegação</h4>
          <ul className="mt-5 space-y-3 text-sm">
            <li><Link to="/" className="hover:text-[#E84E34] transition-colors">Início</Link></li>
            <li><Link to="/produtos" className="hover:text-[#E84E34] transition-colors">Produtos</Link></li>
            <li><Link to="/sobre" className="hover:text-[#E84E34] transition-colors">Quem Somos</Link></li>
            <li><Link to="/contato" className="hover:text-[#E84E34] transition-colors">Contato</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-xs font-bold uppercase tracking-[0.2em] text-[#E84E34]">Contato</h4>
          <ul className="mt-5 space-y-3 text-sm text-white/80">
            <li className="flex items-start gap-3">
              <Phone size={16} className="mt-1 flex-shrink-0 text-[#E84E34]" />
              <div>
                <div>{CONTACTS.eronilde.display} — Eronilde</div>
                <div>{CONTACTS.aline.display} — Aline</div>
                <div>(54) 3019-8737 / 3019-1380</div>
              </div>
            </li>
            <li className="flex items-start gap-3">
              <Mail size={16} className="mt-1 flex-shrink-0 text-[#E84E34]" />
              <div>
                <div>comercial@avantech.inf.br</div>
                <div>eronilde@avantech.inf.br</div>
              </div>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-xs font-bold uppercase tracking-[0.2em] text-[#E84E34]">Endereço</h4>
          <ul className="mt-5 space-y-3 text-sm text-white/80">
            <li className="flex items-start gap-3">
              <MapPin size={16} className="mt-1 flex-shrink-0 text-[#E84E34]" />
              <div>
                Rua José Soares de Oliveira, 2490<br />
                Bairro Pio X — Caxias do Sul/RS<br />
                CEP 95034-100
              </div>
            </li>
            <li className="flex items-start gap-3">
              <Clock size={16} className="mt-1 flex-shrink-0 text-[#E84E34]" />
              <div>
                Seg a Qui: 7h30–12h / 13h–17h30<br />
                Sex: 7h–12h / 13h–16h30
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <div>© {new Date().getFullYear()} Avantech Soluções Tecnológicas Ltda. CNPJ 48.805.542/0001-68</div>
          <div className="font-mono-sm flex items-center gap-2" data-testid="footer-credit">
            <span>Desenvolvido por</span>
            <span className="text-white font-bold tracking-wider">KODE STUDIO</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
